import gql from 'graphql-tag';

export default gql`
  fragment salesforceTaskPriorityFragment on SalesforceTaskPriority {
    id
    masterLabel
    taskPriority
  }
`;
